import { render, staticRenderFns } from "./ProductInventoryMaxPerOrder.vue?vue&type=template&id=e07ff9b6&"
import script from "./ProductInventoryMaxPerOrder.vue?vue&type=script&lang=ts&"
export * from "./ProductInventoryMaxPerOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports